export function isStreamedFlightClarifyError(entry: {
  flightResponse?: { error?: unknown; errorStatus?: unknown } | null;
  searchProgressMessagesOnly?: boolean;
  searchProgress?: { cards?: unknown[] } | null;
}): boolean {
  const fr = entry?.flightResponse;
  if (typeof fr?.error !== "string") return false;

  const sp = entry?.searchProgress;
  const messagesOnly =
    entry?.searchProgressMessagesOnly === true ||
    (!!sp && !(Array.isArray(sp.cards) && sp.cards.length > 0));
  if (!messagesOnly) return false;

  // Only user-input (4xx) errors — i.e. the refine-able / incomplete-query case.
  // 5xx (transient) stays visible.
  const status = fr?.errorStatus;
  return typeof status === "number" && status >= 400 && status < 500;
}
